/**
 * Given a list of triggers, calls callback function whenever the first
 * trigger is fired.
 * @param {import('./Trigger').Trigger[]} triggers
 * @param {CallableFunction} callback
 */
function onFirst(triggers, callback) {
  function onFire() {
    triggers.forEach((trigger) => trigger.destroy())
    callback()
  }

  triggers.forEach((trigger) => {
    trigger.subscribe(onFire)
  })
}

export { onFirst }
